const Patient = () => import(/* webpackChunkName: "pasienmobilemedicalindex" */ '@/views/private/mobile/medical/Index.vue')
// const General = () => import(/* webpackPrefetch: true */ '@/views/private/mobile/medical/General.vue')
// const PatientGeneral = () => import(/* webpackPrefetch: true */ '@/components/general/Index.vue')
// const PatientSupport = () => import(/* webpackPrefetch: true */ '@/components/general/Support.vue')

const routes = [
  {
    path: "/mobile/patient",
    name: "patient",
    component: Patient,
    meta: {
      title: "Data Pasien"
    }
  },
  // {
  //   path: "/patient/general",
  //   name: "patient general",
  //   component: General,
  //   meta: {
  //     title: "Data Pasien"
  //   },
  //   children: [
  //     {
  //       path: '/patient/general/main',
  //       name: ' patient general main',
  //       component: PatientGeneral,
  //       meta: {
  //         title: "Form Data Pasien"
  //       }
  //     },
  //     {
  //       path: '/patient/general/support',
  //       name: ' patient general support',
  //       component: PatientSupport,
  //       meta: {
  //         title: "Form Pendukung Data Pasien"
  //       }
  //     },
  //   ]
  // }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})